import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function HomeTestimonials() {
  const getSlides = () => {
    if (window.innerWidth <= 768) return 1;
    if (window.innerWidth <= 1024) return 2;
    return 3;
  };

  const [slidesToShow, setSlidesToShow] = useState(getSlides());
  const [sliderKey, setSliderKey] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setSlidesToShow(getSlides());
      setSliderKey((prev) => prev + 1);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    swipeToSlide: true,

    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnHover: true,
    pauseOnFocus: true,

    centerMode: true,
    centerPadding: "0px",

    arrows: false,
  };
  return (
    <section className="home-testimonials-main-bg-conatiner">
      <div className="home-testimonials-main-bg-content">
        <h3 className="home-testimonials-heading">What Customers Say</h3>

        <Slider key={sliderKey} {...settings}>
          <div className="testimonial-slide-home">
            <div className="testimonial-card-home">
              <p className="testimonial-card-home-star">
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
              </p>
              <p className="testimonial-card-home-description">
             The jewellery looks premium and very elegant. Quality is amazing and exactly as shown. Perfect for gifting.
              </p>
              <div className="testimonial-card-user-details">shani</div>
            </div>
          </div>

          <div className="testimonial-slide-home">
            <div className="testimonial-card-home">
              <p className="testimonial-card-home-star">
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
              </p>
              <p className="testimonial-card-home-description">
          Design is classy and finishing is excellent. The packaging was neat and delivery was on time. Very satisfied.
              </p>
              <div className="testimonial-card-user-details">Neha Sharma</div>
            </div>
          </div>

          <div className="testimonial-slide-home">
            <div className="testimonial-card-home">
              <p className="testimonial-card-home-star">
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
              </p>
              <p className="testimonial-card-home-description">
              Great Quality & Elegant Design
Ordered from Kuina for the first time and I’m impressed. The jewellery feels luxurious and looks beautiful.
              </p>
              <div className="testimonial-card-user-details">Pooja Mehta </div>
            </div>
          </div>

          <div className="testimonial-slide-home">
            <div className="testimonial-card-home">
              <p className="testimonial-card-home-star">
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
              </p>
              <p className="testimonial-card-home-description">
           Perfect Gift Choice
Bought this for my wife and she absolutely loved it. Kuina jewellery looks premium and stylish.
              </p>
              <div className="testimonial-card-user-details"> Ankit Verma </div>
            </div>
          </div>

          <div className="testimonial-slide-home">
            <div className="testimonial-card-home">
              <p className="testimonial-card-home-star">
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
              </p>
              <p className="testimonial-card-home-description">
             Highly Recommended Brand
Kuina offers amazing designs with great quality. Comfortable to wear and looks expensive. Will shop again.
              </p>
              <div className="testimonial-card-user-details">Ritu Kapoor</div>
            </div>
          </div>

          <div className="testimonial-slide-home">
            <div className="testimonial-card-home">
              <p className="testimonial-card-home-star">
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
              </p>
              <p className="testimonial-card-home-description">
              Worth Every Penny
The craftsmanship is really good and the product looks exactly like the pictures. Kuina never disappoints.
              </p>
              <div className="testimonial-card-user-details"> Shreya Joshi</div>
            </div>
          </div>
        </Slider>
      </div>
    </section>
  );
}

export default HomeTestimonials;
